<template>
    <div>
        <!-- <b-row>
            <b-col sm="12">
                <span style="color: red;">※ 주문번호를 클릭 하시면 주문 상세 내역을 확인 할 수 있습니다.</span>
            </b-col>
        </b-row> -->
        <b-row>
            <b-col sm="12">
                <b-table outlined 
                         hover
                         sticky-column 
                         responsive
                         :fields="fields" 
                         :items="items" 
                         :busy="items == 0"
                         :current-page="currentPage" 
                         :per-page="perPage"
                         @row-clicked="rowOrderOpenModal">
                         <div slot="table-busy" class="text-center my-2">
                            <strong>데이터가 없습니다.</strong>
                        </div>
                        <template slot="amount" slot-scope="row">
                            {{ row.item.amount | numberComma }}
                        </template>
                        <template slot="dc_price" slot-scope="row">
                            {{ row.item.dc_price | numberComma }}
                        </template>
                        <template slot="price" slot-scope="row">
                            {{ row.item.price | numberComma }}
                        </template>
                </b-table>
            </b-col>
            <b-col sm="12">
                <b-pagination v-model="currentPage" 
                            :totalRows="totalRows" 
                            :per-page="perPage"
                            align="center"></b-pagination>
            </b-col>
        </b-row>

        <UserOrderDetailModal v-bind:formModal="formModal" v-bind:item="item" />
    </div>
</template>
<script>
import { EventBus } from "../../../../../event-bus";
import UserOrderDetailModal from "./UserOrderDetailModal";

export default {
    name: "userOrderList",
    props: {
        userId: {
            type: String,
            default: ""
        },
    },
    created() {
      // 이벤트 버스 선언
      EventBus.$on('callOrderCloseModal', () => {
        this.closeOrderModal();
      });
    },
    data() {
        return {
            fields: [
                , { 'order_code': { 'label': '주문번호', thClass: 'thClass_w08', tdClass: 'textAlignCenter' } }
                , { 'order_pname': { 'label': '상품명' , thClass: 'thClass_other', tdClass: 'tdClass' } }
                , { 'order_date': { 'label': '주문일', thClass: 'thClass_w08', tdClass: 'textAlignCenter' } }
                , { 'pay_type_name': { 'label': '결제방식', thClass: 'thClass_w08', tdClass: 'textAlignCenter' } }
                , { 'price': { 'label': '주문금액', thClass: 'thClass_w08', tdClass: 'textAlignCenter' } }
                , { 'dc_price': { 'label': '할인금액', thClass: 'thClass_w08', tdClass: 'textAlignCenter' } }
                , { 'amount': { 'label': '결제금액', thClass: 'thClass_w08', tdClass: 'textAlignCenter' } }
                , { 'status_name': { 'label': '주문상태', thClass: 'thClass_w08', tdClass: 'textAlignCenter' } }
            ],
            items: [],
            currentPage: 1,
            perPage:10,
            totalRows:0,
            formModal: false,
            item: {},
        }
    },
    watch: {
        userId: function (value, oldValue) {
            this.findOrderList();
        },
    },
    methods: {
        findOrderList() {
            var token = sessionStorage.getItem("myToken");
            
            this.$http.get('/api/select/userDrOrderList?access_token='+token + '&user_id=' + this.userId + '&order_type=RP')
                    .then((result) => {
                    this.items = result.data;
                    this.totalRows = this.items.length;
                })
        },
        rowOrderOpenModal(item, index) {
            // console.log(item);
            this.item = item;
            this.formModal = true;
        },
        closeOrderModal() {
            this.formModal = false;
        },
    },
    components:{
        UserOrderDetailModal,
    }
}
</script>


// WEBPACK FOOTER //
// src/views/user/userDetail/component/tabs/order/UserOrderList.vue